export default "__VITE_ASSET__Dt70$I8K__"